<div *ngIf="roles$ | async as roles">
  <nav class="mobile-nav">
    <button class="mobile-nav-btn mobile-nav-btn--left" type="button" (click)="showNavigationPopOver()" aria-label="Toggle menu">
      <i class="fas fa-bars"></i>
    </button>

    <ng-template #hamburgerMenu> </ng-template>

    <div class="mobile-nav-logo">
      <img src="/Progreso/assets/images/logo.png" alt="Progreso logo" (click)="navigateToHomePage()" />
    </div>

    <div class="mobile-nav-btn mobile-nav-btn--right">
      <div class="profile" *ngIf="currentEmployee$ | async as currentEmployee">
        <div ngbDropdown class="d-inline-flex align-items-center" id="profileDrop">
          <ng-container *ngIf="myProfileMenuItem$ | async as myProfileMenuItem; else profilepictureneeded">
            <button *ngIf="myProfileMenuItem; else profilepictureneeded" class="profilePicture ms-2 me-1 p-0 btn no-bg" type="button" [title]="myProfileMenuItem.label">
              <app-profile-picture [text]="currentEmployee.firstName + ' ' + currentEmployee.lastName" [whoKind]="whoKind" ngbDropdownToggle> </app-profile-picture>
            </button>
          </ng-container>
          <ng-template #profilepictureneeded>
            <div class="profilePicture ms-2 me-1 mainProfile no-bg" style="cursor: default !important">
              <app-profile-picture [text]="currentEmployee.firstName + ' ' + currentEmployee.lastName" [whoKind]="whoKind" ngbDropdownToggle></app-profile-picture>
            </div>
          </ng-template>
          <button type="button" ngbDropdownToggle></button>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButtonProfile">
            <app-role-dropdown></app-role-dropdown>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>

<div class="mobile-menu-backdrop" *ngIf="toggleHamburgerMenu" (click)="closeNavigationPopOver()"></div>
<div class="mobile-menu" [class.open]="toggleHamburgerMenu">
  <div class="mobile-menu-header">
    <div class="mobile-nav-logo mt-3">
      <img src="/Progreso/assets/images/logo.png" alt="Progreso logo" />
    </div>
    <button class="menu-close-btn" type="button" aria-label="Close menu" (click)="closeNavigationPopOver()">&times;</button>
  </div>
  <div class="mobile-menu-content mt-4">
    <div class="row">
      <div class="col-6 d-flex align-items-center">
        <i class="fa fa-solid fa-user me-3"></i>
        <h2 class="fw-bold" *ngIf="roleLabel.length">
          {{ roleLabel | label : 'header_breadcrumb' | async }}
        </h2>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end">
        <a class="logoff fw-bold me-3" (click)="logOff()" *ngIf="logoffLabel$ | async as logoffLabel">
          {{ logoffLabel.labelText }}
        </a>
      </div>
    </div>
    <ng-container *ngIf="currentEmployee$ | async as currentEmployee">
      <div class="row mt-4">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <app-profile-picture [whoKind]="whoKind" [whoId]="currentEmployee.studentId" [width]="80"></app-profile-picture>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <span *ngIf="birthdayToday">
            <i class="fas fa-birthday-cake me-2"></i>
          </span>
          <h2>
            {{ greetingLabel | label : 'header_breadcrumb' | async }}
            {{ currentEmployee.firstName }} {{ currentEmployee.lastName }}
          </h2>
        </div>
      </div>
    </ng-container>
    <div class="row mt-4">
      <div class="col-12 p-2">
        <div class="tabs-container">
          <ul ngbNav #nav="ngbNav" [activeId]="activeTab" (navChange)="onNavChange($event)" class="nav nav-tabs">
            <li class="nav-item" [ngbNavItem]="1">
              <a class="nav-link" ngbNavLink>{{ 'navigation' | label : 'navigation' | async }}</a>
              <ng-template ngbNavContent>
                <div class="nav-card p-2" #navCard>
                  <div class="nav-card-item nav-card-back" *ngIf="menuStack.length" (click)="goBack()" role="button" tabindex="0" aria-label="Ga terug naar het vorige overzicht">
                    <i class="fas fa-chevron-left back-icon"></i>
                    <span class="label">{{ 'back_to_upper_navigation_level' | label : 'mobile_employee_home_page_mobile' | async }}</span>
                  </div>

                  <ng-container *ngFor="let menuItem of currentMenuItems">
                    <div *ngIf="!menuItem.hideInNavigation" class="nav-card-item mt-3">
                      <h2 class="label" (click)="navigate($event, menuItem)" tabindex="0" role="button">
                        {{ menuItem.label }}
                      </h2>
                      <i class="fas fa-chevron-right" *ngIf="menuItem.subPages?.length" (click)="toggleSubmenu(menuItem); $event.stopPropagation()" style="font-size: 20px; cursor: pointer"></i>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
            </li>

            <li class="nav-item" [ngbNavItem]="2">
              <a class="nav-link" ngbNavLink>{{ 'selectyourrole' | label : 'login01' | async }}</a>
              <ng-template ngbNavContent>
                <div class="p-2">
                  <app-role-dropdown></app-role-dropdown>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="tab-content"></div>
        </div>
      </div>
    </div>
  </div>
</div>
